// services
import { useStore } from '@/store';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';

export const useProjectSGCategoryTemplateService = () => {
    const { apiUrl } = useStore().state;
    const axios = useAxios();

    const handlerEndpoint = 'projectsg-category-template';

    const getAllProjectSGCategoryTemplate = async (): Promise<any[]> => {
        const res = await axios.get(`${apiUrl}/${handlerEndpoint}`);
        return (res.data||[]);
    };

    const getAllProjectSGCategoryTemplateAsTree = async (): Promise<any[]> => {
        const res = await axios.get(`${apiUrl}/${handlerEndpoint}/tree`);
        return res.data;
    };

    const getProjectSGCategoryTemplate = async (id): Promise<any> => {
        const res = await axios.get(`${apiUrl}/${handlerEndpoint}/${id}`);
        return res.data;
    };

    const createProjectSGCategoryTemplate = async (
        payload: any,
    ): Promise<any> => {
        const res = await axios.post(`${apiUrl}/${handlerEndpoint}`, payload);
        return res.data;
    };

    const deleteProjectSGCategoryTemplate = async (id: number) => {
        const res = await axios.deleteId(`${apiUrl}/${handlerEndpoint}/${id}`);
        return res;
    };

    const updateProjectSGCategoryTemplate = async (
        project: any,
    ): Promise<any> => {
        const res = await axios.put(`${apiUrl}/${handlerEndpoint}`, project);
        return res.data;
    };

    return {
        getAllProjectSGCategoryTemplate,
        getAllProjectSGCategoryTemplateAsTree,
        getProjectSGCategoryTemplate,
        createProjectSGCategoryTemplate,
        deleteProjectSGCategoryTemplate,
        updateProjectSGCategoryTemplate,
    };
};
